export default __webpack_public_path__ + "static/media/10.72b885da.jpg";